




































































import { Component, Watch, Mixins, Ref } from 'vue-property-decorator';
import SFormElement from './SFormElement.vue';
import SDatepickerBase from './SDatepickerBase.vue';
import SInputBase from './SInputBase.vue';
import SElementValidationErrors from './SElementValidationErrors.vue';
import dayjs from '@/utils/dayjs';

@Component({
  components: {
    SInputBase,
    SElementValidationErrors,
    SDatepickerBase,
  },
})
export default class SDatetimepicker extends Mixins(SFormElement) {
  private timeObject?: dayjs.Dayjs;
  private date = '';
  private hour = '';
  private minute = '';
  private second = '';

  @Ref() private readonly minuteRef!: SInputBase;
  @Ref() private readonly secondRef!: SInputBase;

  private get listeners() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { input, ...listeners } = this.$listeners;
    return listeners;
  }

  private get isoTime() {
    return this.timeObject ? this.timeObject.format() : '';
  }

  private goToMinute() {
    this.minuteRef.focus();
    this.minuteRef.select();
  }

  private goToSecond() {
    this.secondRef.focus();
    this.secondRef.select();
  }

  private emptyOutsideValue() {
    this.$emit('input', '');
  }

  @Watch('value', { immediate: true })
  private readOutsideValue() {
    if (!this.value) {
      return;
    }

    const newTimeObject = this.$dayjs.utc(this.value);

    if (newTimeObject.isValid()) {
      this.timeObject = newTimeObject;
      this.setInputsFromTimeObject(newTimeObject.local());
    }
  }

  private handleInput() {
    this.hour = this.padTime(this.hour);
    this.minute = this.padTime(this.minute);
    this.second = this.padTime(this.second);
    const iso = `${this.date}T${this.hour}:${this.minute}:${this.second}`;

    const newTimeObject = this.$dayjs(iso, 'YYYY-MM-DDTHH:mm:ss', true);

    if (newTimeObject.year() < 1900) {
      // any date before 1895-01-01 causes weird bugs (presumably javascript number handling)
      // https://gitlab.dodo.no/fakturabank/snotr/client_vue/merge_requests/309#note_27341
      if (!this.value) {
        this.date = this.$dayjs().format('YYYY-MM-DD');
      } else {
        this.readOutsideValue();
      }
    } else if (newTimeObject.isValid()) {
      this.$emit('input', newTimeObject.utc().format('YYYY-MM-DDTHH:mm:ssZ'));
    } else {
      this.readOutsideValue();
    }
  }

  private setInputsFromTimeObject(timeObject: dayjs.Dayjs) {
    this.date = timeObject.format('YYYY-MM-DD');
    this.hour = timeObject.format('HH');
    this.minute = timeObject.format('mm');
    this.second = timeObject.format('ss');
  }

  @Watch('hour')
  private handleHourChange() {
    this.hour = this.coerceTime(this.hour);

    if (!this.hour) {
      this.emptyOutsideValue();
    } else if (!this.validTimeComponent(this.hour, 'hour')) {
      this.hour = '';
    } else if (this.hour.length === 2) {
      this.goToMinute();
    }
  }

  @Watch('minute')
  private handleMinuteChange() {
    this.minute = this.coerceTime(this.minute);

    if (!this.minute) {
      this.emptyOutsideValue();
    } else if (!this.validTimeComponent(this.minute, 'minute')) {
      this.minute = '';
    } else if (this.minute.length === 2) {
      this.goToSecond();
    }
  }

  @Watch('second')
  private handleSecondChange() {
    this.second = this.coerceTime(this.second);

    if (!this.second) {
      this.emptyOutsideValue();
    } else if (!this.validTimeComponent(this.second, 'second')) {
      this.second = '';
    } else if (this.second.length === 2) {
      this.secondRef.blur();
    }
  }

  private validTimeComponent(timeComp: string, place: 'hour' | 'minute' | 'second') {
    const upperBound = place === 'hour' ? 23 : 59;
    const asNum = parseInt(timeComp);

    if (asNum <= upperBound) return true;
    return false;
  }

  private coerceTime(time: string) {
    time = time.replace(/\D+/g, '');
    if (time.length > 2) return time.slice(0, 2);
    return time;
  }

  private padTime(time: string) {
    if (time.length === 1) return '0' + time;
    return time;
  }
}
